import angular from 'angular';
import Breadcrumb from './breadcrumb/breadcrumb.component';
import PostCodeAutocomplete from './postcode/postcode-autocomplete.component';
import StoreFinder from './storefinder/store-finder.component';
import ProductSuggestion from './product-suggestion/product-suggestion.component';

let commonComponentModule = angular.module('app.common.components', [])
    .component('breadcrumb', Breadcrumb)
    .component('postCodeAutocomplete', PostCodeAutocomplete)
    .component('storeFinder', StoreFinder)
    .component('productSuggestion', ProductSuggestion);

export default commonComponentModule;


// WEBPACK FOOTER //
// ./src/app/common/components.common.js